const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js';

export const analyticsArgs = {
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
};

const CONSENT_AFTER_OPT_IN = {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
};

export function isBrowserEnvironment() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function isAnalyticsLoaded() {
    return isBrowserEnvironment() && typeof window.gtag === 'function';
}

function getDisableFlag(measurementId) {
    return `ga-disable-${measurementId}`;
}

function loadAnalytics({ measurementId }) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('consent', 'default', CONSENT_AFTER_OPT_IN);
    window.gtag('js', new Date());
    window.gtag('config', measurementId);

    const script = document.createElement('script');
    script.async = true;
    script.src = `${GTAG_SRC}?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);
}

export function setAnalyticsConsent(isGranted) {
    const { measurementId } = analyticsArgs;
    if (!isBrowserEnvironment() || !measurementId) {
        return;
    }

    if (isGranted) {
        window[getDisableFlag(measurementId)] = false;
        if (isAnalyticsLoaded()) {
            window.gtag('consent', 'update', { analytics_storage: 'granted' });
        } else {
            loadAnalytics(analyticsArgs);
        }
        return;
    }

    if (isAnalyticsLoaded()) {
        window[getDisableFlag(measurementId)] = true;
        window.gtag('consent', 'update', { analytics_storage: 'denied' });
    }
}
